import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import "../style/page-layout.css";

const PageLayout = ({ children }) => {
  return (
    <div className="page-layout-wrapper">
      <Navbar />
      <div className="page-content-scroll">
        {children || <Outlet />}
      </div>
    </div>
  );
};

export default PageLayout;
